export default __webpack_public_path__ + "static/SRF 2100 - Product Specifications & Technical Data-9afa6d44e412c7b5824e81fa1ac1daae.pdf";